import { CalendarTodayOutlined, ScheduleOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { FORTA_GRAY4, FORTA_GRAY7 } from '../../../../../utils/colors';
import {
  ACTIVITY_DATE_FORMAT,
  ACTIVITY_STATUS_LABEL_KEYS,
  ACTIVITY_STATUS_STAGE,
  ACTIVITY_TIME_FORMAT,
  ACTIVITY_TYPE,
} from '../constants';
import {
  ACTIVITY_CARD_BODY_SX,
  ACTIVITY_CARD_HEADER_SX,
  ACTIVITY_CARD_STARTED_ROW_SX,
  ACTIVITY_CARD_STARTED_SX,
  ACTIVITY_CARD_SX,
  ACTIVITY_STATUS_COLOR,
} from '../styles';
import ActivityStageMeter from './ActivityStageMeter';

import type { ActivityCardProps } from '../types';

function ActivityCard({ activity, onClick }: ActivityCardProps) {
  const { t } = useTranslation('dashboard');
  const startedAt = moment(activity.startedAt);
  const title =
    activity.type === ACTIVITY_TYPE.ONBOARDING_QUESTIONNAIRE
      ? t('activities.onboardingQuestionnaire')
      : t('activities.intakeQuestionnaire');

  return (
    <Box
      data-testid={`activityCard-${activity.type}-${activity.id}`}
      onClick={onClick}
      sx={ACTIVITY_CARD_SX}
    >
      <Box sx={ACTIVITY_CARD_HEADER_SX}>
        <Typography fontSize={16} lineHeight={1.5} color={FORTA_GRAY4}>
          {title}
        </Typography>
        {Boolean(activity.clientName) && (
          <Typography fontSize={14} lineHeight={1.5} color={FORTA_GRAY4}>
            {t('activities.client', { name: activity.clientName })}
          </Typography>
        )}
      </Box>
      <Box sx={ACTIVITY_CARD_BODY_SX}>
        <Box sx={ACTIVITY_CARD_STARTED_SX}>
          <Typography fontSize={14} lineHeight={1.5} color={FORTA_GRAY7}>
            {t('activities.started')}
          </Typography>
          <Box sx={ACTIVITY_CARD_STARTED_ROW_SX}>
            <CalendarTodayOutlined sx={{ fontSize: 16 }} />
            <Typography fontSize={14} lineHeight={1.5}>
              {startedAt.format(ACTIVITY_DATE_FORMAT)}
            </Typography>
          </Box>
          <Box sx={ACTIVITY_CARD_STARTED_ROW_SX}>
            <ScheduleOutlined sx={{ fontSize: 16 }} />
            <Typography fontSize={14} lineHeight={1.5}>
              {startedAt.format(ACTIVITY_TIME_FORMAT)}
            </Typography>
          </Box>
        </Box>
        <ActivityStageMeter
          stage={ACTIVITY_STATUS_STAGE[activity.status]}
          color={ACTIVITY_STATUS_COLOR[activity.status]}
          label={t(ACTIVITY_STATUS_LABEL_KEYS[activity.status])}
        />
      </Box>
    </Box>
  );
}

export default ActivityCard;
